import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {IPost, Post} from "../models/post.model";
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicationService {

  localStorage: Storage = localStorage;

  constructor(private http: HttpClient) { }

  all(): Observable<any>{
    return this.http.get(`${environment.url}/v1/post/all`);
  }

  allPosts(page: number, size: number): Observable<any>{
    return this.http.get(`${environment.url}/v1/post/all?fields=postProducts,postServiceModels,postSubProducts&page=${page}&size=${size}`);
  }

  allEmployeJobPosts(page: number, size: number): Observable<any>{
    //return this.http.get(`${environment.url}/v1/posts?fields=postProducts,postServiceModels,postSubProducts`);
    return this.http.get(`${environment.url}/v1/posts/job?fields=postProducts,postServiceModels,postSubProducts&page=${page}&size=${size}`);
  }

  allEmployeJobPostsByDate(startDate: any, endDate: any, page: number, size: number): Observable<any>{
    //return this.http.get(`${environment.url}/v1/posts?fields=postProducts,postServiceModels,postSubProducts`);
    return this.http.get(`${environment.url}/v1/posts/job?fields=postProducts,postServiceModels,postSubProducts&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }


  getKahpooPostByDate(startDate: any, endDate: any ,page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/post/all?fields=postProducts,postServiceModels,postSubProducts&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  disablePost(id: number): Observable<any>{
    const headers = new HttpHeaders();
    headers.set('kapo_session_id', localStorage.getItem('kapo_session_id'))
    return this.http.put(`${environment.url}/post/inactive/${id}`, null, {'headers': headers});
  }

  // enablePost(id: number): Observable<any>{
  //   const headers = new HttpHeaders();
  //   headers.set('kapo_session_id', localStorage.getItem('kapo_session_id'))
  //   return this.http.put(`${environment.url}/post/active/${id}`, null, {'headers': headers});
  // }

  enablePost(id: number): Observable<any> {
    const headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id'));

    return this.http.put(`${environment.url}/post/back/active/${id}`, null, { headers });
  }

  getPostById(idA:any){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/v1/posts/`+idA+'?fields=postSubProducts,postServiceModels,postPromotions,category,postProducts',{'headers': headers});
  }

  getPost(id: number): Observable<any>{
    return this.http.get(`${environment.url}/post/${id}`);
  }

  totalPurchase(id: number): Observable<any>{
    return this.http.get(`${environment.url}/order_item/sellByPost/${id}`);
  }

  updatePost(Post:IPost) : Observable<any>{
    const headers = new HttpHeaders();
    headers.set('kapo_session_id', localStorage.getItem('kapo_session_id'))
    return this.http.put<any>(`${environment.url}/post/${Post.id}`, Post,{'headers': headers});
  }

  deletePost(id: number) : Observable<any>{
    const headers = new HttpHeaders();
    headers.set('kapo_session_id', localStorage.getItem('kapo_session_id'))
    return this.http.delete<any>(`${environment.url}/post/${id}`,{'headers': headers});
  }

  notesAndCommentsByPostId(id: number): Observable<any>{
    return this.http.get(`${environment.url}/v1/posts/${id}/notePost`);
  }

  getIdPost(idP:any){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/v1/posts/`+idP+'?fields=postSubProducts,postServiceModels,postPromotions,category,postProducts',{'headers': headers});
  }

  //api/promotion/product
  isKahpooProductPromotion(): Observable<any>{
    return this.http.get(`${environment.url}/promotion/kahpoo/product`);
  }

  //api/promotion/service
  isKahpooServicePromotion(): Observable<any>{
    return this.http.get(`${environment.url}/promotion/kahpoo/service`);
  }

  allSellerPosts(
    page: number,
    size: number,
    isFilterByProductAndService: boolean,
    isFilterByService: boolean,
    isFilterByProduct: boolean,
    startDate?: string,
    endDate?: string,
    postSearchText?: string,
    statusSearchText?: string
  ): Observable<any> {
      let params = new HttpParams()
          .set('fields', 'postServiceModels,postPromotions,postSubProducts')
          .set('page', page.toString())
          .set('size', size.toString())
          .set('isFilterByProductAndService', isFilterByProductAndService.toString())
          .set('isFilterByService', isFilterByService.toString())
          .set('isFilterByProduct', isFilterByProduct.toString());

      if (startDate) {
          params = params.set('startDate', startDate);
      }
      if (endDate) {
          params = params.set('endDate', endDate);
      }
      if (postSearchText) {
          params = params.set('postSearchText', postSearchText);
      }
      if (statusSearchText) {
          params = params.set('statusSearchText', statusSearchText);
      }

      return this.http.get(`${environment.url}/v1/kahpoo/posts/allsellerpost`, { params });
  }


}
